import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { buildQueryParams } from '../utils/buildQueryParams';
import { withForcedLedgerReadMode } from '../utils/ledgerReadMode';
import { authFetch } from '../lib/authFetch';

export interface ForecastPeriod {
  date: string;
  income: number;
  expense: number;
  savings: number;
  netChange: number;
  balance: number;
}

export const useForecast = (
  includeTentative = true,
  startDate?: string,
  endDate?: string
) => {
  const { auth } = useAuth();
  const [data, setData] = useState<ForecastPeriod[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchForecast = async () => {
      setLoading(true);
      try {
        const query = buildQueryParams({
          includeTentative: String(includeTentative),
          ...(startDate ? { startDate } : {}),
          ...(endDate ? { endDate } : {}),
        });

        const res = await authFetch(withForcedLedgerReadMode(`/api/forecast?${query}`), {
          headers: { Authorization: `Bearer ${auth.token}` },
        });

        const result = await res.json();
        setData(result.periods || []);
      } catch (err) {
        console.error('Forecast fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchForecast();
  }, [auth.token, includeTentative, startDate, endDate]);

  return { data, loading };
};
